import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
export const HiddenAreaWidgetServerModelHelper = {
    create: (id, trackingIdentifier, questionText, locations, properties) => ({
        type: WidgetType.hiddenArea,
        id,
        trackingIdentifier,
        data: {
            questionText,
            locations,
        },
        properties,
    }),
    isHiddenAreaWidgetServerModel: (widgetServerModel) => {
        return widgetServerModel.type === WidgetType.hiddenArea;
    },
};
